'use strict';

/**
 * init initilizes vector map plugin
 * @param  {string} scope css selector
 * @return {[undefined]}    [nothing returned]
 */
export function init(scope){

    let pagination = $(scope).find('.pagination').data('pagination');

    let options = {
        valueNames: [ 'eventtype', 'location' ],
        page: pagination,
        plugins: [ ListPagination() ]
    };

    let eventList = new List('events', options);

    //eventList.fuzzySearch.search('vejen');

    if (!!('ontouchstart' in window)) {
        eventList.on('updated', function(){
            App.helpers.scrollToElm('#events', 500);
        });
    }

    $(scope).find('.filter').on('change', '.types, .locations', function(e){

        let searchStr = {};
        let valType = $('#events').find('.types option:selected').val();
        let valLoc = $('#events').find('.locations option:selected').val();


        if(valLoc === 'All'){
            valLoc = '';
        }

        if(valType === 'All'){
            valType = '';
        }


        searchStr.eventType = valType;
        searchStr.eventLocation = valLoc;

        updateList(searchStr, eventList);

        if(eventList.visibleItems.length === 0){
            $(scope).find('.msg').removeClass('hide');
        }else {
            $(scope).find('.msg').addClass('hide');
        }

    });
}



/**
 * [updateList description]
 * @param  {[type]} searchStr [description]
 * @param  {[type]} list      [description]
 * @return {[type]}           [description]
 */
function updateList(searchStr, list){

    list.filter(function(item) {

        var loc = item.values().location.match(/<span class="region hide">(.*?)<\/span>/g);

        if(loc){
            if((searchStr.eventLocation || searchStr.eventLocation === '') && (searchStr.eventType || searchStr.eventType === '')){
                return item.values().eventtype.includes(searchStr.eventType) && loc[0].includes(searchStr.eventLocation);
            }

            if(searchStr.eventType === undefined) {
                return loc[0].includes(searchStr.eventLocation);
            }
        }

        if(searchStr.eventLocation === undefined) {
            return item.values().eventtype.includes(searchStr.eventType);
        }

    });
}
